import { useMemo } from 'react'

import type ViewProductStore from '../../../AppData/_stores/ViewProductStore'
import { useAppSelector } from '../../../Common/_hooks/useAppSelector'

export default function useProductInfoViewProducts(idProduct: number) {
  const productData = useAppSelector(state => state.get('appData').get('products').get(String(idProduct)))
  const viewProducts = useAppSelector(state => state.get('appData').get('viewProducts'))

  return useMemo(() => {
    const tmpViewProducts: ViewProductStore[] = []
    const listViewProductIds = new Set<number>()

    productData?.get('viewProducts').forEach(viewProductId => {
      const viewProduct = viewProducts.get(String(viewProductId))
      if (viewProduct?.get('gpsrInfo')) {
        tmpViewProducts.push(viewProduct)
        listViewProductIds.add(viewProduct.get('id'))
      }
    })

    viewProducts.forEach(viewProduct => {
      if (
        viewProduct?.get('gpsrInfo')
        && viewProduct.get('id_product') === idProduct
        && !listViewProductIds.has(viewProduct.get('id'))
      ) {
        tmpViewProducts.push(viewProduct)
      }
    })

    return tmpViewProducts
  }, [idProduct, productData, viewProducts])
}
